import { env } from '@/config/env';
import { getDefaultLang, getSupportedLocaleCodes } from '@/config/localeSupport';

const _supported = getSupportedLocaleCodes();
export const SUPPORTED_LANGS = _supported;
export const DEFAULT_LANG = getDefaultLang(_supported);

export const TITLE_BY_LANG = {
    cn: env.BASE_NAME_CN,
    'zh-tw': env.BASE_NAME_ZH_TW,
    en: env.BASE_NAME_EN,
    ma: env.BASE_NAME_MA,
    ru: env.BASE_NAME_RU,
    ko: env.BASE_NAME_KO,
    pt: env.BASE_NAME_PT,
    es: env.BASE_NAME_ES,
    vn: env.BASE_NAME_VN,
    ja: env.BASE_NAME_JA,
    de: env.BASE_NAME_DE,
    fr: env.BASE_NAME_FR,
    th: env.BASE_NAME_TH,
    uk: env.BASE_NAME_EN
};

export function getBaseNameByLang(lang) {
    return TITLE_BY_LANG[lang] || env.BASE_NAME_EN || env.BASE_NAME_CN;
}

export const STORAGE_KEYS = {
    token: 'token',
    tokenExpiresAt: 'tokenExpiresAt',
    lang: 'lang',
    redirectPath: 'tourl',
    loginThrottle: 'goLoginDatenow',
    sessionFilesUrl: 'sessionFilesUrl',
    sessionUsername: 'sessionUsername',
    sessionHeadimgurl: 'sessionHeadimgurl',
    sessionUserid: 'sessionUserid',
};
